var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('highcharts',{attrs:{"options":_vm.chartOptions}}),(_vm.flag)?_c('div',{staticClass:"highcharts-alternative-labels"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(index + 1)+"   "+_vm._s(item.name)+" "+_vm._s(item.text)+" "+_vm._s(item.value)+" ")])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }